export default function getChapterAttribute(attribute) {
  return state => state.getIn(['currentChapter', 'data', attribute]);
}
